/**
 * Small country flag rendered as INLINE SVG — no network/CDN dependency, so it
 * renders identically on every OS (unlike emoji flags which show up as bare
 * letter pairs "NO/RO/GB" on Windows) and works offline / on locked networks.
 */
import React, { useRef } from "react";

function Norway() {
  return (
    <svg viewBox="0 0 22 16" width="100%" height="100%" preserveAspectRatio="xMidYMid slice">
      <rect width="22" height="16" fill="#EF2B2D" />
      <rect x="6" width="4" height="16" fill="#fff" />
      <rect y="6" width="22" height="4" fill="#fff" />
      <rect x="7" width="2" height="16" fill="#002868" />
      <rect y="7" width="22" height="2" fill="#002868" />
    </svg>
  );
}

function Romania() {
  return (
    <svg viewBox="0 0 3 2" width="100%" height="100%" preserveAspectRatio="xMidYMid slice">
      <rect width="1" height="2" fill="#002B7F" />
      <rect x="1" width="1" height="2" fill="#FCD116" />
      <rect x="2" width="1" height="2" fill="#CE1126" />
    </svg>
  );
}

function Poland() {
  return (
    <svg viewBox="0 0 8 5" width="100%" height="100%" preserveAspectRatio="xMidYMid slice">
      <rect width="8" height="5" fill="#fff" />
      <rect y="2.5" width="8" height="2.5" fill="#DC143C" />
    </svg>
  );
}

function UK({ uid }) {
  return (
    <svg viewBox="0 0 60 30" width="100%" height="100%" preserveAspectRatio="xMidYMid slice">
      <clipPath id={`uk-s-${uid}`}><path d="M0,0 v30 h60 v-30 z" /></clipPath>
      <clipPath id={`uk-t-${uid}`}><path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z" /></clipPath>
      <g clipPath={`url(#uk-s-${uid})`}>
        <path d="M0,0 v30 h60 v-30 z" fill="#012169" />
        <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
        <path d="M0,0 L60,30 M60,0 L0,30" clipPath={`url(#uk-t-${uid})`} stroke="#C8102E" strokeWidth="4" />
        <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10" />
        <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" />
      </g>
    </svg>
  );
}

let _seq = 0;

export default function LangFlag({ lang, size = 20, className = "", withCode = false }) {
  const uid = useRef(++_seq).current;
  const h = Math.round((size * 3) / 4);
  const Flag = lang === "no" ? Norway : lang === "ro" ? Romania : lang === "pl" ? Poland : UK;
  return (
    <span className={`inline-flex items-center gap-1 ${className}`}>
      <span
        className="inline-block rounded-[2px] overflow-hidden ring-1 ring-black/10 shadow-sm"
        style={{ width: size, height: h, lineHeight: 0 }}
        aria-label={(lang || "").toUpperCase()}
      >
        <Flag uid={uid} />
      </span>
      {withCode && <span className="text-[11px] font-black text-slate-600">{(lang || "").toUpperCase()}</span>}
    </span>
  );
}
